import React from 'react';

const { AdvancedMarker, APIProvider, InfoWindow, Map, useAdvancedMarkerRef } = require('@vis.gl/react-google-maps');

import { Artist as ArtistCell, ShowVertical } from '../common/container/Cell.jsx';
import { NoResults, Spaced, Tab, Title, TitleSpaced, forResource } from '../common/container/Container.jsx';
import { Component as Landmark } from '../common/container/Landmark.jsx';
import { Indicator as LoadingIndicator } from '../common/container/Loading.jsx';
import { Popup } from '../common/container/Popup.jsx';
import HubspotForm from '../common/container/HubspotForm.jsx';
import { Galleries as GalleriesSlider, Shows as ShowsSlider } from '../common/container/Slider.jsx';
import { Follow as FollowButton, LinkButton } from '../common/input/Button.jsx';
import Arrows from '../common/input/Arrows.jsx';
import { LinkedImage } from '../common/container/Image.jsx';
import { publicCompany } from '../common/publicCompany.ts';

let _CityInst;
class _City extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            artists: {
                loading: false,
                q: {
                    limit: 20,
                    offset: 0
                }
            },
            galleries: {
                loading: true,
                mapVisible: true
            },
            showsCurrent: {
                loading: true
            },
            showsPast: {
                loading: false,
                q: {
                    limit: 18,
                    offset: 0,
                    when: 2
                }
            }
        };

        this.showsSliderConfig = {
            items: 2,
            loop: true,
            margin: 16.67,
            nav: true,
            navText: ["", ""],
            responsive: {
                // breakpoint from 0 up
                0: {
                    items: 1,
                    slideBy: 1
                },
                // breakpoint from 768 up
                768: {
                    items: 2,
                    slideBy: 2
                }
            },
            rewindNav: true
        };

        this.configureTabs = this.configureTabs.bind(this);
        this.getArtists = this.getArtists.bind(this);
        this.getGalleries = this.getGalleries.bind(this);
        this.getShowsCurrent = this.getShowsCurrent.bind(this);
        this.getShowsPast = this.getShowsPast.bind(this);
        this.handleArtistFollowChange = this.handleArtistFollowChange.bind(this);
        this.handleArtistsWaypointEnter = this.handleArtistsWaypointEnter.bind(this);
        this.handleFollowChange = this.handleFollowChange.bind(this);
        this.handleGalleryAddClick = this.handleGalleryAddClick.bind(this);
        this.handleGalleryAddClose = this.handleGalleryAddClose.bind(this);
        this.handleMetaClick = this.handleMetaClick.bind(this);
        this.handleShowsWaypointEnter = this.handleShowsWaypointEnter.bind(this);
        this.handleToggleGalleryMapVisibilty = this.handleToggleGalleryMapVisibilty.bind(this);
    }

    componentDidMount() {
        _CityInst = true;

        const component = this;
        component.props.onRegisterRequestCallback(function (responseData) {
            Artcloud.mkt.cities._isfollowing(responseData);

            const id = component.props.slug;
            component.getArtists(id);
            component.getGalleries(id);
            component.getShowsCurrent(id);
            component.getShowsPast(id);
            component.configureTabs();
        });
    }

    componentWillUnmount() {
        _CityInst = undefined;

        if (this.artistsRequest) {
            this.artistsRequest.abort();
            this.artistsRequest = null;
        }
        if (this.galleriesRequest) {
            this.galleriesRequest.abort();
            this.galleriesRequest = null;
        }
        if (this.showsCurrentRequest) {
            this.showsCurrentRequest.abort();
            this.showsCurrentRequest = null;
        }
        if (this.showsPastRequest) {
            this.showsPastRequest.abort();
            this.showsPastRequest = null;
        }
    }

    configureTabs() {
        const tabs = [
            { active: true, label: 'Overview', tab: 'overview' },
            { label: 'Shows', tab: 'shows' },
            { label: 'Galleries', tab: 'galleries' },
            { label: 'Artists', tab: 'artists' },
            { label: 'Museums', tab: 'museums' }
        ];
        this.props.onConfigureTabs(tabs, 'overview');
    }

    getArtists(id) {
        const component = this;
        const state = component.state.artists;
        if (state.loading) {
            return;
        }
        state.loading = true;
        component.setState({
            artists: state
        });
        component.artistsRequest = Artcloud.api.get(
            Artcloud.url.vendor.marketplace.cities.artists.get(id),
            state.q,
            function (responseData) {
                component.artistsRequest = null;

                responseData.Artists.forEach(function (d) {
                    if (d.Image) {
                        d.ImgSrc = d.Image.Url;
                    }
                    Artcloud.mkt.artists._isfollowing(d);
                });
                let data = state.data || [];
                state.data = data.concat(responseData.Artists);

                state.q.offset += responseData.Artists.length;
                state.total = responseData.Total;

                state.loading = false;
                component.setState({
                    artists: state
                });
            },
            function (jqXHR, textStatus) {
                component.artistsRequest = null;

                if (!state.data) {
                    state.data = [];
                }
                state.loading = false;
                component.setState({
                    artists: state
                });
                Artcloud.api.fail(jqXHR, textStatus);
            }
        );
    }

    getGalleries(id) {
        const component = this;
        component.galleriesRequest = Artcloud.api.get(
            Artcloud.url.vendor.marketplace.cities.galleries.get(id),
            null,
            function (responseData) {
                component.galleriesRequest = null;

                const data = [];
                const featured = [];
                responseData.Data.forEach(function (d) {
                    Artcloud.mkt.galleries._isfollowing(d);

                    if (d.Image && d.IsFeatured) {
                        featured.push(d);
                    }
                    if (d.Company) {
                        d.mapLabel = {
                            color: '#fff',
                            text: d.Company.split(' ').map(function (v) {
                                const name = v.toUpperCase();
                                const articles = ['THE', 'OF', 'AT', 'IN', 'A', 'AN'];
                                if (!articles.includes(name)) {
                                    return name[0];
                                }
                            }).slice(0, 2).join(''),
                        };
                    }
                    data.push(d);
                })
                component.setState({
                    galleries: {
                        all: data,
                        featured: featured,
                        mapVisible: component.state.galleries.mapVisible
                    }
                });
            },
            function (jqXHR, textStatus) {
                component.galleriesRequest = null;

                component.setState({
                    galleries: {
                        all: [],
                        featured: [],
                        mapVisible: component.state.galleries.mapVisible
                    }
                });
                Artcloud.api.fail(jqXHR, textStatus);
            }
        );
    }

    getShowsCurrent(id) {
        const component = this;
        component.showsCurrentRequest = Artcloud.api.get(
            Artcloud.url.vendor.marketplace.cities.shows.get(id),
            { when: 1 },
            function (responseData) {
                component.showsCurrentRequest = null;
                component.setState({
                    showsCurrent: {
                        data: responseData.Shows,
                        total: responseData.Total
                    }
                });
            },
            function (jqXHR, textStatus) {
                component.showsCurrentRequest = null;

                component.setState({
                    showsCurrent: {
                        data: []
                    }
                });
                Artcloud.api.fail(jqXHR, textStatus);
            }
        );
    }

    getShowsPast(id) {
        const component = this;
        const state = component.state.showsPast;
        if (state.loading) {
            return;
        }
        state.loading = true;
        component.setState({
            showsPast: state
        });
        component.showsPastRequest = Artcloud.api.get(
            Artcloud.url.vendor.marketplace.cities.shows.get(id),
            state.q,
            function (responseData) {
                component.showsPastRequest = null;

                let data = state.data || [];
                state.data = data.concat(responseData.Shows);

                state.q.offset += responseData.Shows.length;
                state.total = responseData.Total;

                state.loading = false;
                component.setState({
                    showsPast: state
                });
            },
            function (jqXHR, textStatus) {
                component.showsPastRequest = null;

                if (!state.data) {
                    state.data = [];
                }
                state.loading = false;
                component.setState({
                    showsPast: state
                });
                Artcloud.api.fail(jqXHR, textStatus);
            }
        );
    }

    handleArtistFollowChange(d) {
        const state = this.state.artists;
        let artist;
        for (let i = 0; i < state.data.length; i++) {
            let temp = state.data[i];
            if (!temp || temp.ArtistId != d.ArtistId) {
                continue;
            }
            artist = temp;
            break;
        }
        if (!artist) {
            return;
        }
        const component = this;
        Artcloud.mkt.artists.updateFollowing(artist.ArtistId, !artist.IsFollowing, artist.Name, function (success) {
            if (success != true || !_CityInst) {
                return;
            }
            artist.IsFollowing = !artist.IsFollowing;
            component.setState({
                artists: state
            });
        });
    }

    handleArtistsWaypointEnter() {
        if (!this.state.artists.data || (this.state.artists.data && this.state.artists.q.offset >= this.state.artists.total)) {
            return;
        }
        this.getArtists(this.props.slug);
    }

    handleFollowChange() {
        const component = this;
        const city = this.props.data;
        Artcloud.mkt.cities.updateFollowing(city.CityId, !city.IsFollowing, component.props.slug, function (success) {
            if (success != true || !_CityInst) {
                return;
            }
            city.IsFollowing = !city.IsFollowing;
            component.props.onUpdateData(city);
        });
    }

    handleGalleryAddClick(event) {
        if (event) {
            event.preventDefault();
        }
        this.setState({
            galleryAddModal: true
        });
    }

    handleGalleryAddClose() {
        this.setState({
            galleryAddModal: undefined
        });
    }

    handleMetaClick(event) {
        if (event) {
            event.preventDefault();
        }
        if (!event.currentTarget.attributes.name || !event.currentTarget.attributes.name.value) {
            return;
        }
        this.props.onTabClick(event.currentTarget.attributes.name.value);
    }

    handleShowsWaypointEnter() {
        if (!this.state.showsPast.data || (this.state.showsPast.data && this.state.showsPast.q.offset >= this.state.showsPast.total)) {
            return;
        }
        this.getShowsPast(this.props.slug);
    }

    handleToggleGalleryMapVisibilty(event) {
        if (event) {
            event.preventDefault();
        }
        const galleries = this.state.galleries;
        galleries.mapVisible = !galleries.mapVisible;
        this.setState({
            galleries: galleries
        });
    }

    render() {
        const data = this.props.data || {};
        const imageStyle = { backgroundSize: 'auto 100%', backgroundColor: '#ffffff' };
        if (data.Image) {
            imageStyle.backgroundImage = `url('${data.Image.Url}')`;
        }
        let className = '';
        let tabExtras;
        if (this.props.tab == 'galleries') {
            tabExtras = (
                <div className="toggle__cont">
                    <a href="#" onClick={this.handleToggleGalleryMapVisibilty}>{this.state.galleries.mapVisible ? 'Show List' : 'Show Map'}</a>
                </div>
            );
            if (this.state.galleries.mapVisible) {
                className += ' tabs__content--no__padding';
            }
        }
        const hasCurrentShows = this.state.showsCurrent.data && this.state.showsCurrent.data.length > 0;

        return (
            <React.Fragment>
                <div className="section">
                    <Spaced className="cover__container cover--city section">
                        <div className="cover__img" style={imageStyle} />
                        <div className="cover__content">
                            <div className="cover__name">
                                <h1>{data.Name}</h1>
                                <h4 className="cover__meta">
                                    {
                                        this.state.showsCurrent.total != undefined &&
                                        this.state.showsPast.total != undefined &&
                                        <a href="#" name="shows" onClick={this.handleMetaClick}>{this.state.showsCurrent.total + this.state.showsPast.total} show{(this.state.showsCurrent.total + this.state.showsPast.total) != 1 ? 's' : ''}</a>
                                    }
                                    {
                                        this.state.galleries.all != undefined &&
                                        <React.Fragment>
                                            <span> - </span>
                                            <a href="#" name="galleries" onClick={this.handleMetaClick}>{this.state.galleries.all.length} galler{this.state.galleries.all.length != 1 ? 'ies' : 'y'}</a>
                                        </React.Fragment>
                                    }
                                    {
                                        this.state.artists.total != undefined &&
                                        <React.Fragment>
                                            <span> - </span>
                                            <a href="#" name="artists" onClick={this.handleMetaClick}>{this.state.artists.total} artist{this.state.artists.total != 1 ? 's' : ''}</a>
                                        </React.Fragment>
                                    }
                                </h4>
                                <br />
                                <FollowButton data={data} onChange={this.handleFollowChange} />
                            </div>
                        </div>
                    </Spaced>
                </div>
                <Tab tabExtras={tabExtras} tabs={this.props.tabs} onClick={this.props.onTabClick}>
                    {
                        this.props.tab == 'galleries' &&
                        !Artcloud.auth.isauthed &&
                        <Spaced className="section banner--add-gallery">
                            <span className="banner__text">Add your gallery to {publicCompany()}'s comprehensive gallery guide</span>
                            <span className="banner__btn">
                                <LinkButton config={{ color: 'dark', size: 'medium', style: 'fill' }} onClick={this.handleGalleryAddClick}>Add My Gallery</LinkButton>
                            </span>
                        </Spaced>
                    }
                </Tab>
                <div className="section spacer--top">
                    {
                        !this.props.data &&
                        <LoadingIndicator />
                    }
                    {
                        this.props.tab == 'overview' &&
                        this.props.data &&
                        <React.Fragment>
                            {
                                this.props.data.Overview &&
                                this.props.data.Overview.length > 0 &&
                                <Spaced className="spacer--bottom">
                                    <p className="text--details">
                                        <span className="all">{this.props.data.Overview}</span>
                                    </p>
                                </Spaced>
                            }
                            {
                                !this.state.showsCurrent.loading &&
                                this.state.showsCurrent.data &&
                                <Spaced className="spacer--bottom">
                                    <ShowsSlider
                                        config={this.showsSliderConfig}
                                        data={this.state.showsCurrent.data}
                                        id="shows"
                                        slideProps={{ height: 250, cols: 2 }}
                                        titleContent={(
                                            <Title className="section__title--medium">
                                                <h2>Shows</h2>
                                                <Arrows display="See All" name="shows" renderAsLink={true} onClick={this.props.onTabClick} />
                                            </Title>
                                        )} />
                                </Spaced>
                            }
                            {
                                this.state.showsCurrent.loading &&
                                !this.state.galleries.loading &&
                                <LoadingIndicator />
                            }

                            {
                                !this.state.galleries.loading &&
                                this.state.galleries.featured &&
                                <GalleriesSlider
                                    data={this.state.galleries.featured}
                                    id="galleries"
                                    titleContent={(
                                        <Title className="section__title--medium">
                                            <h2>Featured Galleries</h2>
                                            <Arrows display="See All" name="galleries" renderAsLink={true} onClick={this.props.onTabClick} />
                                        </Title>
                                    )}
                                />
                            }
                            {
                                this.state.galleries.loading &&
                                <LoadingIndicator />
                            }
                        </React.Fragment>
                    }
                    {
                        this.props.tab == 'shows' &&
                        <div>
                            {
                                hasCurrentShows &&
                                <React.Fragment>
                                    <Spaced>
                                        <TitleSpaced>
                                            <h3>Current and Upcoming Shows</h3>
                                        </TitleSpaced>
                                    </Spaced>
                                    <Spaced className="show__grid--cont">
                                        {this.state.showsCurrent.data.map((d) => <ShowCell key={d.ShowId} d={d} />)}
                                    </Spaced>
                                    <br />
                                </React.Fragment>
                            }
                            {
                                this.state.showsCurrent.loading &&
                                !this.state.showsPast.loading &&
                                <LoadingIndicator />
                            }
                            {
                                this.state.showsPast.data &&
                                this.state.showsPast.data.length > 0 &&
                                <React.Fragment>
                                    <Spaced>
                                        <TitleSpaced>
                                            <h3>Past Shows</h3>
                                        </TitleSpaced>
                                    </Spaced>
                                    <Spaced className="show__grid--cont container--waypoint">

                                        {this.state.showsPast.data.map((d) => <ShowCell key={d.ShowId} d={d} />)}
                                        <div className="loading--waypoint">
                                            <Landmark useWindow={true} onEnter={this.handleShowsWaypointEnter} />
                                        </div>
                                    </Spaced>
                                </React.Fragment>
                            }
                            {
                                this.state.showsPast.loading &&
                                <LoadingIndicator />
                            }
                        </div>
                    }
                    {
                        this.props.data &&
                        <Galleries
                            city={data}
                            data={this.state.galleries}
                            tab={this.props.tab} />
                    }
                    {
                        this.props.tab == 'artists' &&
                        <div>
                            {
                                this.state.artists.data &&
                                <React.Fragment>
                                    {
                                        this.state.artists.data.length == 0 &&
                                        <NoResults display="No Artists" />
                                    }
                                    {
                                        this.state.artists.data.length > 0 &&
                                        <Spaced className="artist__grid--cont container--waypoint">
                                            {this.state.artists.data.map((d) => <ArtistCell key={d.ArtistId} d={d} fixedHeight={true} onFollowChange={this.handleArtistFollowChange} />)}
                                            <div className="loading--waypoint">
                                                <Landmark useWindow={true} onEnter={this.handleArtistsWaypointEnter} />
                                            </div>
                                        </Spaced>
                                    }
                                </React.Fragment>
                            }
                            {
                                this.state.artists.loading &&
                                <LoadingIndicator />
                            }
                        </div>
                    }
                    {
                        this.props.tab == 'museums' &&
                        data.Museums &&
                        data.Museums.length > 0 &&
                        <div className="container container--spaced section" dangerouslySetInnerHTML={{ __html: data.Museums }} />
                    }
                </div>
                {
                    this.state.galleryAddModal &&
                    <GalleryAddModal onClose={this.handleGalleryAddClose} />
                }
            </React.Fragment>
        )
    }
}

class Galleries extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};

        this.handleMapMarkerClick = this.handleMapMarkerClick.bind(this);
        this.handleMapMarkerClose = this.handleMapMarkerClose.bind(this);
        this.handleSideBarClick = this.handleSideBarClick.bind(this);
    }

    handleMapMarkerClick(galleryId) {
        let gallery, temp;
        for (let i = 0; i < this.props.data.all.length; i++) {
            temp = this.props.data.all[i];
            if (temp.GalleryId != galleryId) {
                continue;
            }
            gallery = temp;
            break;
        }
        if (!gallery) {
            return;
        }
        this.setState({
            activeGallery: gallery
        });

        let element;
        if (gallery.IsFeatured) {
            element = document.getElementById(`featured-${gallery.GalleryId}`);
        } else {
            element = document.getElementById(`all-${gallery.GalleryId}`);
        }
        const container = document.getElementById('galleries__map-sidebar');
        if (!container || !element) {
            return;
        }
        container.scrollTop = element.offsetTop - (container.offsetHeight / 2) + (element.offsetHeight / 2);
    }

    handleMapMarkerClose() {
        this.setState({
            activeGallery: undefined
        });
    }

    handleSideBarClick(d) {
        // Clear the existing active gallery before setting the new one (ensure UI updates properly)
        const component = this;
        component.setState({
            activeGallery: undefined
        }, function () {
            const activeGallery = { ...d };
            activeGallery.spiderfy = true;
            component.setState({
                activeGallery: activeGallery
            });
        });
    }

    render() {
        const component = this;
        const activeId = component.state.activeGallery ? component.state.activeGallery.GalleryId : undefined;
        const props = component.props;
        const Cell = props.data.mapVisible ? GallerySideBarCell : GalleryCell;
        let content = (
            <React.Fragment>
                {
                    props.data.loading &&
                    <LoadingIndicator />
                }
                {
                    props.data.featured &&
                    props.data.featured.length > 0 &&
                    <React.Fragment>
                        <Title className="section__title--medium">
                            <h4>Featured Galleries</h4>
                        </Title>
                        <div className="gallery__grid__cont">
                            {props.data.featured.map((d) => <Cell key={d.GalleryId} active={d.GalleryId == activeId} d={d} featured={true} onClick={component.handleSideBarClick} />)}
                        </div>
                    </React.Fragment>
                }
                {
                    !props.data.loading &&
                    <React.Fragment>
                        <Title className="section__title--medium">
                            <h4 className="m-b-sm">All Galleries</h4>
                        </Title>
                        {
                            props.data.all.length == 0 &&
                            <NoResults display="No Results" />
                        }
                        {
                            props.data.all.length > 0 &&
                            <div className="letters--grid">
                                {props.data.all.map((d) => <Cell key={d.GalleryId} active={d.GalleryId == activeId} d={d} onClick={component.handleSideBarClick} />)}
                            </div>
                        }
                    </React.Fragment>
                }
            </React.Fragment>
        );

        let className;
        if (props.data.mapVisible) {
            className = 'galleries__map map--view__container container--split split';
            content = (
                <div className="map--view__sidebar split--fixed__view" id="galleries__map-sidebar">
                    {content}
                </div>
            );
        } else {
            className = 'galleries__thumb';
        }
        let style;
        if (props.tab != 'galleries') {
            if (props.data.loading) {
                style = { opacity: 0 };
            } else {
                style = { display: 'none' };
            }
        }
        return (
            <div className="section">
                <Spaced className={className} style={style}>
                    {content}
                    {
                        props.data.mapVisible &&
                        <div className="map--view__map-container split--toggle__view">
                            <div className="split__content">
                                <MapView
                                    activeGallery={component.state.activeGallery}
                                    data={props.data.all}
                                    latitude={props.city.Latitude}
                                    longitude={props.city.Longitude}
                                    onMarkerClick={component.handleMapMarkerClick}
                                    onMarkerClose={component.handleMapMarkerClose} />
                            </div>
                        </div>
                    }
                </Spaced>
            </div>
        );
    }
}

class GalleryAddModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};

        this.handleChange = this.handleChange.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange(name, value) {
        this.setState({
            [name]: value
        });
    }

    handleClose(event) {
        if (event) {
            event.preventDefault();
        }
        if (!this.state.loading && this.props.onClose) {
            this.props.onClose();
        }
    }

    handleSubmit(event) {
        if (event) {
            event.preventDefault();
        }
    }

    render() {
        return (
            <Popup className="text--center popup--add-gallery" type='container' onClose={this.handleClose}>
                <img alt="" className="form--signup__logo" src="../assets/img/logos/header-mark-center-dark.svg" />
                <h5 className="form--signup__header">Add your gallery to <br />{publicCompany()}'s comprehensive gallery guide</h5>
                <HubspotForm formId="04e7a9e3-e95a-4ec1-8e31-68cc95c1a474" portalId="4285812" onFormSubmitted={this.handleClose} />
            </Popup>
        )
    }
}

function GalleryCell(props) {
    const data = props.d || {};
    const link = `/gallery/${data.Slug}`;
    let content = <a href={link}>{data.Company}</a>;
    if (props.featured) {
        content = (
            <div className="gallery__info">
                {content}
            </div>
        );
    }
    return (
        <div className="grid grid--4">
            <div className="gallery__grid">
                {
                    props.featured &&
                    data.Image &&
                    <LinkedImage
                        alt={data.Company}
                        imageClass={"gallery__img"}
                        image={data.Image}
                        link={link}
                        type={"fill"}
                        cols={3}
                    />
                }
                {content}
            </div>
        </div>
    );
}

class GallerySideBarCell extends React.Component {
    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(event) {
        if (event) {
            event.preventDefault();
        }
        this.props.onClick(this.props.d);
    }

    render() {
        let className = 'grid grid--3';
        if (this.props.active) {
            className += ' active';
        }
        const data = this.props.d || {};
        const id = (this.props.featured ? 'featured-' : 'all-') + data.GalleryId;
        return (
            <div className={className} id={id} onClick={this.handleClick}>
                <div className="gallery__grid">
                    {

                        this.props.featured &&
                        <React.Fragment>
                            {
                                data.Image &&
                                <LinkedImage
                                    alt={data.Company}
                                    imageClass={"gallery__img--cover"}
                                    image={data.Image}
                                    type={"fill"}
                                    height={100}
                                    width={100}
                                />
                            }
                            <div className="gallery__info">
                                <h3 className="gallery__info__title">{data.Company}</h3>
                                {
                                    data.Artists != undefined &&
                                    <p className="gallery__info__meta">{data.Artists} artist{data.Artists != 1 ? 's' : ''}</p>
                                }
                                {
                                    data.Artworks != undefined &&
                                    <p className="gallery__info__meta">{data.Artworks} artwork{data.Artworks != 1 ? 's' : ''}</p>
                                }
                                <LinkButton config={{ color: 'dark', size: 'tiny' }} link={`/gallery/${data.Slug}`}>View Profile</LinkButton>
                            </div>
                        </React.Fragment>
                    }
                    {
                        !this.props.featured &&
                        data.Company
                    }
                </div>
            </div >
        );
    }
}

function MapView(props) {
    const [loadingApi, setLoadingApi] = React.useState(true);
    const handleApiLoaded = () => setLoadingApi(false);

    const [markers, setMarkers] = React.useState([]);
    const handleMarker = (id, marker) => {
        const _markers = markers;
        _markers.push({ id, element: marker });
        setMarkers(_markers);
    }
    const [overlappingDetails, setOverlappingDetails] = React.useState(undefined);
    const _rectsOverlap = (r1, r2) => !(r1.top > r2.bottom || r1.right < r2.left || r1.bottom < r2.top || r1.left > r2.right)
    const handleMarkerClick = (id, marker, data) => {
        // Find markers that overlap with the one that was clicked
        const markerRect = marker.getBoundingClientRect();
        let overlapping = [];
        markers.forEach(d => {
            if (d.id != id && _rectsOverlap(markerRect, d.element.getBoundingClientRect())) {
                overlapping.push(d);
            }
        });
        if (overlapping.length) {
            // Add the clicked marker to the beginng of the list so it displays at the top of the spider and the info window won't overlap other spidered markers
            overlapping.splice(0, 0, ({ id, element: marker }));

            // Determine the angle and radius between spidered markers
            const angle = (2.0 * Math.PI) / overlapping.length;
            let radius;
            if (overlapping.length < 4) {
                radius = 20;
            } else if (overlapping.length < 8) {
                radius = 32;
            } else {
                radius = 48;
            }

            // Add an angle offset for odd counts so the clicked element always displays at the top by itself
            const offset = overlapping.length % 2 ? 0 : angle / 2;
            let overlappingMarkerMap = {};
            overlapping.forEach((d, i) => {
                // Rotate the calculated angle by 90deg so the angles start at the "top" of the circle instead of the "right"
                const theta = offset + (i * angle) + (Math.PI / 2.0);

                // Offset the origin by half the size of the marker (32px x 22px)
                const x = radius * Math.cos(theta) + 16;
                const y = radius * Math.sin(theta) + 11;
                overlappingMarkerMap[d.id] = { x, y }
            })

            // Store the map and the click position from which markers will spider
            const _details = { map: overlappingMarkerMap, position: data.latLng && { lat: data.latLng.lat(), lng: data.latLng.lng() } }
            setOverlappingDetails(_details)
        } else {
            // No overlaps => Clear out any current overlap details
            setOverlappingDetails(undefined);
        }
        props.onMarkerClick(id);
    }
    const handleMarkerClose = () => {
        setOverlappingDetails(undefined);
        props.onMarkerClose();
    }

    const _data = props.data || [];
    const markerData = _data.map((d, i) => ({
        id: d.GalleryId,
        label: d.mapLabel,
        position: {
            lat: d.Latitude,
            lng: d.Longitude
        },
        slug: d.Slug,
        title: d.Company,
        zIndex: (i + 1)
    }));
    return (
        <APIProvider apiKey="AIzaSyCrgYYx5ISnIYiSDriVBse4tWZEV5Xc48A" onLoad={handleApiLoaded}>
            {
                loadingApi ?
                    <div style={{ height: `100%` }} />
                    :
                    <>
                        <Map
                            clickableIcons={false}
                            defaultCenter={{ lat: props.latitude, lng: props.longitude }}
                            defaultZoom={13}
                            fullscreenControl={false}
                            mapId="355b77d9f9171f11bd6523e8"
                            mapTypeControl={false}
                            mapTypeId="roadmap"
                            streetViewControl={false}
                            style={{ height: '100%' }}
                            onClick={handleMarkerClose}>
                            {
                                markerData.map((marker) =>
                                    <MapMarker
                                        key={marker.id}
                                        activeGallery={props.activeGallery}
                                        {...marker}
                                        overlappingDetails={overlappingDetails}
                                        onClick={handleMarkerClick}
                                        onClose={handleMarkerClose}
                                        onMarker={handleMarker}>
                                    </MapMarker>
                                )
                            }
                        </Map>
                    </>
            }
        </APIProvider>
    )
}

function MapInfoWindow(props) {
    const data = props.d || {};
    return (
        <InfoWindow
            id="infoWindow"
            anchor={props.anchor}
            pixelOffset={[0, -12]}
            shouldFocus={true}
            onCloseClick={props.onCloseClick}>
            <div className="marker--popup">
                {
                    data.ImageUrl &&
                    data.ImageUrl.length &&
                    <div className="marker--popup__image" style={{ backgroundImage: `url('${data.ImageUrl}')` }} />
                }
                <div className="marker--popup__title"><h3>{data.Company}</h3></div>
                {
                    data.Artists > 0 &&
                    <div className="marker--popup__artists">{data.Artists} artist{data.Artists != 1 ? 's' : ''}</div>
                }
                {
                    data.Artworks > 0 &&
                    <div className="marker--popup__artworks">{data.Artworks} artwork{data.Artworks != 1 ? 's' : ''}</div>
                }
                <div className="marker--popup__link">
                    <LinkButton config={{ color: 'dark', size: 'tiny' }} link={`/gallery/${data.Slug}`} target="_blank">View More</LinkButton>
                </div>
            </div>
        </InfoWindow>
    );
}

function MapMarker(props) {
    const [markerRef, marker] = useAdvancedMarkerRef();
    React.useEffect(() => {
        if (!marker || !props.onMarker) {
            return;
        }
        props.onMarker(props.id, marker);
    }, [marker])

    const handleClick = (data) => {
        props.onClick(props.id, marker, data);
    }
    const style = {
        backgroundColor: '#333333',
        border: '1px solid #555555',
        borderRadius: '8px',
        color: '#ffffff',
        fontFamily: 'Roboto, Arial, sans-serif',
        fontSize: '14px',
        height: '22px',
        lineHeight: '20px',
        textAlign: 'center',
        width: '32px'
    };
    let position = props.position;
    let x = 15;
    let y = 10;
    if (props.overlappingDetails) {
        const markerDetails = props.overlappingDetails.map[props.id];
        if (markerDetails) {
            position = props.overlappingDetails.position;
            x = markerDetails.x;
            y = markerDetails.y;
        }
    }
    return (
        <AdvancedMarker
            ref={markerRef}
            {...props}
            anchorPoint={[`${x}px`, `${y}px`]}
            position={position || props.position}
            onClick={handleClick}>
            <div style={style}>{props.label && props.label.text}</div>
            {
                props.activeGallery &&
                props.activeGallery.GalleryId == props.id &&
                <MapInfoWindow
                    anchor={marker}
                    d={props.activeGallery}
                    onCloseClick={props.onClose} />
            }
        </AdvancedMarker>
    )
}

function ShowCell(props) {
    return (
        <div className="grid grid--6 spacer--bottom">
            <ShowVertical
                className="show__grid"
                cols={2}
                slider={false}
                {...props} />
        </div>
    )
}

const City = forResource(_City, Artcloud.url.vendor.marketplace.cities.getid);
export default City;